
<template>
<div class="footer" style="background-color:#f6f6f6;border-top:1px solid #ddd;padding-bottom:10px;">
    <div class="container" style="background-color:rgba(255,255,255,0.85);border-right:1px solid #ddd;border-bottom:1px solid #ddd;border-left:1px solid #ddd;">
        <div style="padding:20px 0px 0px 0px;font-size:18px;line-height:24px;">
            <p style="color:#888;font-size:18px;">
                Geofolio is developed by <a href="https://mapworks.nl">Mapworks</a>, a GIS and web mapping studio based in The Hague. Our mission is to make environmental data accessible and understandable for everyone. Get in touch with us via info@geofolio.org for questions, feedback, or collaboration.
            </p>
            <p style="color:#888;font-size:18px;margin-top:15px;">
                Geofolio uses cookies to be able to provide login functionality. No AI tools were used to produce text or visual content for this site.
            </p>
            <div class="row">
                <div class="col-lg">                    
                    <p style="color:#888;">
                        <a href="/blog/">Blog</a> | 
                        <a href="/about/">About</a> | 
                        <a href="/docs/frequently-asked-questions/">Frequently Asked Questions</a>
                    </p>
                </div>
                <div class="col-lg text-right">
                    <p style="color:#888;">
                        <a href="/terms-of-service/">Terms of Service</a> | 
                        <a href="/privacy/">Privacy</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
  
  export default {
    name: 'footer',
    components: {
    },
    computed: {
        profile() {
            if(this.$store.state.profile) {
                return this.$store.state.profile
              } else {
                return this.$store.state.profile_pub;
              }
        }
    },
  }
</script>

<style>

</style>